import { BaseballLineupPosition } from '@trackman/baseball-shared-components';
import { BasePositions } from './BasePositions';

export const AllPositions: string[] = [
  ...BasePositions,
  BaseballLineupPosition.Catcher,
  BaseballLineupPosition.CenterField,
  BaseballLineupPosition.DesignatedHitter,
  BaseballLineupPosition.FirstBase,
  BaseballLineupPosition.LeftField,
  BaseballLineupPosition.Pitcher,
  BaseballLineupPosition.RightField,
  BaseballLineupPosition.SecondBase,
  BaseballLineupPosition.Shortstop,
  BaseballLineupPosition.ThirdBase,
  BaseballLineupPosition.Undefined,
];
